import React from 'react'
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';

import CCOHeadline from '../../fundamentals/CCOHeadline';
import CCOOverlay from "../../fundamentals/CCOOverlay";
import CCOLinkButton from "../../fundamentals/CCOLinkButton";
import {RichTextElement} from "../../fundamentals/CCORichText/CCORichTextHelper";
import CCORichText from "../../fundamentals/CCORichText/CCORichText";
import PreviewElementBoxDrawer from "../../preview/PreviewElementBoxDrawer";
import CCOResponsivePicture from "../../fundamentals/CCOResponsivePicture";
import {C060OverlayTeaserPictureSettings} from "../../../common/constants/pictureSettings";
import { getLengthLimit } from "../../../utility/lengthLimits";
import { usePreviewLimitCheck } from "../../preview/usePreviewLimitCheck";
import { stripTreeText } from "../../../utility/componentUtil";
import {CmTeasableType} from "../../types";


export interface Props {
    id: string,
    breakpoints: any,
    details: RichTextElement,
    isPreview?: boolean,
    itemId: string,
    picture: any,
    title: string | null | undefined,
    linksTarget: CmTeasableType[] | null
}

const contentStyle = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    alignSelf: 'stretch',
    padding: {
        xs: '24px 16px 24px 16px',
        md: '32px 32px 48px 32px'
    },
    'a': {
        fontSize: '15px'
    }
}

const imageWrapperStyle = {
    width: {xs: '100%', md: '300px', lg: '375px'},
    maxWidth: {xs: '100%', md: '300px', lg: '375px'}
}

function C060OverlayTeaser({
                               breakpoints,
                               details,
                               isPreview,
                               itemId,
                               picture,
                               title,
                               linksTarget,
                               id
                           }: Props) {
    const ctaButton = linksTarget && linksTarget[0];

    const headlineLimit = getLengthLimit('C060OverlayTeaser.headline');
    const detailsLimit = getLengthLimit('C060OverlayTeaser.details');

    usePreviewLimitCheck({
        id,
        component: 'C060OverlayTeaser',
        field: 'title',
        value: title || '',
        limit: headlineLimit,
        source: 'default',
    });

    usePreviewLimitCheck({
        id,
        component: 'C060OverlayTeaser',
        field: 'details',
        value: details ? stripTreeText(details) : '',
        limit: detailsLimit,
        source: 'default',
    });

    return (
        <React.Fragment>
            <CCOOverlay isPreview={isPreview} breakpoints={breakpoints} withAutoOpen
                        autoOpenKey={`teaserOverlayShown-${itemId}`}
                        noMaxHeight>
                <Box sx={{
                    display: 'flex',
                    height: 'max-content',
                }}>
                    <PreviewElementBoxDrawer propertyId={id}>
                        <Grid container sx={{alignContent: 'flex-start'}}>
                            <Grid sx={imageWrapperStyle}>
                                <CCOResponsivePicture pictureSetting={C060OverlayTeaserPictureSettings}
                                                      picture={picture}
                                                      imageStyle={{width: "100%", height: "auto"}}/>
                            </Grid>
                            <Grid
                                size={{sm: 12, md: 7}}
                                sx={{
                                    maxWidth: '100%',
                                    backgroundColor: 'background.default'
                                }}>
                                <Box sx={contentStyle}>

                                    <CCOHeadline metadataId={id} type='h3'
                                                 headline={title}
                                                 headlineCharLimit={headlineLimit}
                                                 margin={{b: '8px'}}
                                                 propertyName='properties.title'
                                                 color='text.primary'
                                    />
                                    <CCORichText metadataId={itemId} charLimit={detailsLimit} textAsTree={details} propertyName='properties.details'/>
                                    {ctaButton && <CCOLinkButton id={ctaButton.id}
                                                                 url={ctaButton?.selfUrl ?? ''}
                                                                 backgroundColor='tertiary.main'
                                                                 color='tertiary.contrastText'>
                                        {ctaButton?.teaserTitle}
                                    </CCOLinkButton>}
                                </Box>
                            </Grid>
                        </Grid>
                    </PreviewElementBoxDrawer>
                </Box>
            </CCOOverlay>
        </React.Fragment>
    );
}

export default C060OverlayTeaser;